document.addEventListener("DOMContentLoaded",function(){const productForms=document.querySelectorAll('form[data-type="add-to-cart-form"]');productForms.forEach((form)=>{const formId=form.id;const quantityInputs=document.querySelectorAll(`input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`);if(quantityInputs.length===0)return;form.addEventListener("submit",function(e){const activeQuantityInput=quantityInputs[0];const quantity=parseInt(activeQuantityInput.value)||1;form.querySelectorAll('input[type="hidden"][name="quantity"]').forEach((input)=>{input.remove()});const qtyInput=document.createElement("input");qtyInput.type="hidden";qtyInput.name="quantity";qtyInput.value=quantity;form.appendChild(qtyInput)})});function handleResponsiveProductTitles(){const productTitles=document.querySelectorAll(".shop-product-title[data-font-size][data-mobile-font-size]");productTitles.forEach((title)=>{function adjustTitleFontSize(){const desktopSize=title.getAttribute("data-font-size");const mobileSize=title.getAttribute("data-mobile-font-size");if(window.innerWidth<=767){title.style.setProperty("font-size",`${mobileSize}px`,"important")}else{title.style.setProperty("font-size",`${desktopSize}px`,"important")}}
adjustTitleFontSize();if(!title.hasAttribute("data-resize-listener-added")){window.addEventListener("resize",adjustTitleFontSize);title.setAttribute("data-resize-listener-added","true")}})}
handleResponsiveProductTitles();function initFaqAccordions(){const faqContainers=document.querySelectorAll(".product-faq");faqContainers.forEach((faqContainer)=>{const faqId=faqContainer.id;if(!faqId)return;const faqItems=faqContainer.querySelectorAll(".faq-item");const innerFaqContainer=faqContainer.querySelector(".faq-container");const isAccordion=innerFaqContainer&&innerFaqContainer.getAttribute("data-accordion")==="true";faqItems.forEach((item)=>{const question=item.querySelector(".faq-question");if(!question)return;if(!question.hasAttribute("data-click-listener-added")){question.setAttribute("data-click-listener-added","true");question.addEventListener("click",()=>{const isActive=item.classList.contains("active");if(isAccordion&&!isActive){faqItems.forEach((otherItem)=>{otherItem.classList.remove("active")})}
item.classList.toggle("active")})}})})}
initFaqAccordions();const readMoreLinks=document.querySelectorAll(".shop-read-more");const readLessLinks=document.querySelectorAll(".shop-read-less");readMoreLinks.forEach((link)=>{link.addEventListener("click",function(e){e.preventDefault();const parent=this.closest(".shop-product-description");parent.querySelector(".shop-truncated-description").style.display="none";parent.querySelector(".shop-full-description").style.display="block"})});readLessLinks.forEach((link)=>{link.addEventListener("click",function(e){e.preventDefault();const parent=this.closest(".shop-product-description");parent.querySelector(".shop-truncated-description").style.display="block";parent.querySelector(".shop-full-description").style.display="none"})})})

/* Royelia: los combos siempre se agregan y abren el carrito lateral. */
;(function () {
  if (window.__royeliaSideCartBound) return;
  window.__royeliaSideCartBound = true;

  function selectedVariantId() {
    var selected = document.querySelector('.ro-combo.is-selected, .ro-combo.selected, .ro-combo[aria-pressed="true"]');
    var form = document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('input[name="id"]');
    return (selected && selected.dataset.realVariantId) || (input && input.value);
  }

  function openSideCart(button) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) icon.click();
      return;
    }
    fetch('/cart?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open(button);
        else {
          drawer.classList.add('active');
          drawer.removeAttribute('aria-hidden');
        }
      })
      .catch(function () {
        if (typeof drawer.open === 'function') drawer.open(button);
      });
  }

  window.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[id^="ProductSubmitButton-template"]');
    if (!button || button.dataset.sideCartLoading === '1') return;
    var variantId = selectedVariantId();
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    button.dataset.sideCartLoading = '1';
    button.disabled = true;
    var original = button.innerHTML;
    button.textContent = 'Agregando al carrito...';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_add_failed');
        return response.json();
      })
      .then(function () { openSideCart(button); })
      .catch(function () { alert('No pudimos agregar el combo. Por favor, intentá nuevamente.'); })
      .finally(function () {
        button.disabled = false;
        button.innerHTML = original;
        delete button.dataset.sideCartLoading;
      });
  }, true);
})();
